import { showMatchTypePopup } from "@/entities/bottom-popup"
import { showNotification } from "@/entities/notification"
import { revalidateUser } from "@/entities/user"
import { registerNotification } from "@/shared/api/websocket"
import { captureError } from "@/shared/lib/diagnostics"

registerNotification("age_verified_by_moderator", {
	handle: ({ notification_id }, ctx) => {
		showNotification({
			type: "unlock",
			placement: "app",
			variant: "age-verified",
			origin: "server",
			notificationId: notification_id,
			name: "age_verified_by_moderator",
		})
		revalidateUser(ctx.queryClient).catch((error: unknown) => {
			captureError(error, { scope: "ageVerifiedByModerator.revalidate" })
		})
	},
	route: () => ({ to: "/home" }),
	routePopup: () => showMatchTypePopup(),
})

registerNotification("trust_gate_confirmed_by_friend", {
	handle: ({ notification_id }) => {
		showNotification({
			type: "unlock",
			placement: "app",
			variant: "account-confirmed",
			origin: "server",
			notificationId: notification_id,
			name: "trust_gate_confirmed_by_friend",
		})
	},
	route: () => ({ to: "/home" }),
	routePopup: null,
})

registerNotification("trust_gate_confirmed_by_system", {
	handle: ({ notification_id }) => {
		showNotification({
			type: "unlock",
			placement: "app",
			variant: "account-confirmed",
			origin: "server",
			notificationId: notification_id,
			name: "trust_gate_confirmed_by_system",
		})
	},
	route: () => ({ to: "/home" }),
	routePopup: null,
})
